import * as React from 'react'
import { Button, Input, Modal } from 'antd-v4'
import { useState } from 'react'
import { isNil } from 'lodash'
import {
  API,
  ICompanyWithMetaDataContract,
  IUpdateCompanyWithMetaDataContract,
  MetaDataType,
  MetaKeys,
} from '@getgreenline/homi-shared'
import { parseErrorMsg } from '../../../utilities/helpers'
import { FormError } from '../../../components/FormError'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { CurrencyInput } from '../../../components/CurrencyInput'
import { message } from 'antd'

interface Props {
  onClose: () => void
  visible: boolean
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

const _RedemptionConversionRateModal = ({
  onClose,
  visible,
  currentCompanyStore,
}: Props & InjectedProps) => {
  const [pointsValue, setPointsValue] = useState(currentCompanyStore!.loyaltyPointsMultiplier)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [isSaving, setIsSaving] = useState(false)

  const onRedemptionRateUpdate = async (value: number) => {
    try {
      setErrorMessage(null)
      setIsSaving(true)
      const companyContract: IUpdateCompanyWithMetaDataContract<MetaDataType> = {
        metaData: {
          [MetaKeys.loyaltyPointsMultiplier]: value,
        },
      }

      const updatedCompany: ICompanyWithMetaDataContract<MetaDataType.INTEGER> =
        await API.updateCompanyWithMetaData(currentCompanyStore!.company!.id, companyContract, true)

      const newRedemptionRate = updatedCompany.metaData[MetaKeys.loyaltyPointsMultiplier]

      if (isNil(newRedemptionRate)) {
        throw new Error(
          'Error retrieving updated redemption conversion rate. Please refresh the page and try again',
        )
      }

      currentCompanyStore!.loyaltyPointsMultiplier = newRedemptionRate

      message.success('Updated')
      onClose()
    } catch (error) {
      setErrorMessage(
        parseErrorMsg(error) ||
          'An error occurred when updating loyalty redemption rate. Please refresh page and try again',
      )
    } finally {
      setIsSaving(false)
    }
  }

  const onSave = () => {
    onRedemptionRateUpdate(pointsValue)
  }

  return (
    <Modal
      title={'Redemption conversion rate'}
      visible={visible}
      width={750}
      centered
      onCancel={onClose}
      footer={[
        <Button key={'Cancel'} onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key={'Apply'}
          type='primary'
          loading={isSaving}
          onClick={onSave}
          disabled={isNil(pointsValue)}
        >
          Apply
        </Button>,
      ]}
    >
      <div
        className='mb-3 mt-2'
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <div style={{ width: '60%' }}>
          Will consider this value to apply to all loyalty tiers in your dashboard.
        </div>
        <Input value={'100 points'} disabled={true} style={{ width: '100px' }}></Input>
        <div className='ml-1 mr-1'> is worth $</div>
        <CurrencyInput
          centValue={pointsValue}
          onChange={(newValue) => setPointsValue(newValue)}
          onlyPositiveNumber={true}
          autoFocus={true}
          className={'gr-currency-input'}
        ></CurrencyInput>
      </div>
      {errorMessage && <FormError message={errorMessage} />}
    </Modal>
  )
}

export const RedemptionConversionRateModal = inject('currentCompanyStore')(
  observer(_RedemptionConversionRateModal),
)
